<template>
  <PreviewCvSkryV2
    v-if="cv && template === templateOptions[Template.SKRY_V2] && !loadingCv"
    id="preview-cv"
    :cv="cv"
    :language-code="languageCode"
    :show-dates="true"
    :show-duration="true"
    :show-areas-of-expertise="false"
    :show-skills="true"
    :show-github="false"
    :show-gravatar="true"
    :format-project-date="formatProjectDate"
    :format-project-duration="formatProjectDuration"
    :show-educations="true"
    :show-educations-description="false"
    :show-education-dates="true"
    :show-education-skills="true"
    :skill-category-scale="1"
    :cv-options="cvOptions"
  />
</template>

<script setup lang="ts">
import { LanguageCode, useI18n } from "@/i18n";
import { onMounted, ref } from "vue";
import { CvOptionsInterface, cvUserDataInterface } from "../types";
import { apiGetSharedCv } from "../_utils/api";
import { useRouter } from "vue-router/composables";
import PreviewCvSkryV2 from "../_components/templates/PreviewCvSkryV2.vue";
import { useDateFormatter } from "../_utils/dateFormatting";
import { sortByCustomSortOrder } from "@/modules/cv/_utils/sorting";

const router = useRouter();

enum Template {
  SKRY_V2 = 0,
}

const templateOptions = ref<string[]>(["Skry V2"]);
const loadingCv = ref<boolean>(false);
const template = ref<string>(templateOptions.value[Template.SKRY_V2]);
const cv = ref<cvUserDataInterface | undefined>(undefined);
const languageCode = ref<LanguageCode>(LanguageCode.English);
const cvOptions = ref<CvOptionsInterface | undefined>({
  theme: "black",
  skillTheme: "black",
  highlighting: ["bold"],
  branding: ["skry", "skry background"],
});

const dateFormat = ref<string>("");
const { formatProjectDate, formatProjectDuration } = useDateFormatter(dateFormat);
const { locale } = useI18n();
onMounted(async () => {
  loadingCv.value = true;
  const shareToken = router.currentRoute.params["share_token"];
  const useBranding = router.currentRoute.query["use_branding"];
  languageCode.value = router.currentRoute.query["lang"] as LanguageCode;
  if (!Object.values(LanguageCode).includes(languageCode.value)) {
    languageCode.value = LanguageCode.English;
  }
  locale.value = languageCode.value;
  if (useBranding === "false") {
    cvOptions.value.branding = [];
  }
  const { data } = await apiGetSharedCv(shareToken, languageCode.value);
  cv.value = data.data;
  cv.value && sortAllSkills(cv.value);
  loadingCv.value = false;
});

const sortAllSkills = (cv: cvUserDataInterface) => {
  const sortSkills = <A,>(obj: A) => ({
    ...obj,
    skills: sortByCustomSortOrder(
      obj.skills,
      cv.skills,
      (obj) => obj.id,
      (s) => s.id
    ),
  });
  cv.work_experiences = cv.work_experiences.map(sortSkills);
  cv.skill_categories = cv.skill_categories.map(sortSkills);
};
</script>
